import Base from './base'
import performance, { LOFT_START_MARK } from '../services/performance'
import office from '../office/office'
import { Utilities } from '@microsoft/office-js-helpers'

const STAT_NAME = 'outlook.web_request'

export default class MelodyStats extends Base {
  STATS_TAG_LOFTING = 'request:loft_from_outlook'
  STATS_TAG_SUCCESS = 'result:success'
  STATS_TAG_FAILURE = 'result:failure'

  loftResults(extraTags: string[] = []) {
    const tags = [
      this.STATS_TAG_LOFTING,
      `outlook_requirements_set:${office.requirementSet}`,
      `outlook_hostname:${office.office.context.mailbox.diagnostics.hostName}`,
      `outlook_platform:${Utilities.platform}`,
      ...extraTags,
    ]
    const duration = performance.measureFrom(LOFT_START_MARK).duration

    return {
      tags,
      duration,
    }
  }

  loftSuccess(tags: string[] = []) {
    const results = this.loftResults([...tags, this.STATS_TAG_SUCCESS])
    return this.timing(results.duration, results.tags)
  }

  loftFailure(tags: string[] = []) {
    const results = this.loftResults([...tags, this.STATS_TAG_FAILURE])
    return this.timing(results.duration, results.tags)
  }

  track(body: any) {
    return this.api.post('stats', body)
  }

  timing(value: number, tags: string[]) {
    return this.track({ stat: STAT_NAME, type: 'timing', value, tags })
  }
}
